import Vue from 'vue';
import Router from 'vue-router';
import VueCompositionAPI, { reactive, watch } from '@vue/composition-api';
import loginNavigationGuard from './navigationguards/loginNavigationGuard';
import underEditNavigationGuard from './navigationguards/underEditNavigationGuard';
import alreadyLoggedInNavigationGuard from './navigationguards/alreadyLoggedInNavigationGuard';
import LoggedIn from '../components/LoggedIn.vue';
import store from '../store/store';
import { privateRoutes } from '../modules/subModules';
import publicRoutes from './publicRoutes/publicRoutes';

const NotFound = () => import('../components/error/NotFound.vue');
const PublicView = () => import('@/components/public/PublicView.vue');

Vue.use(VueCompositionAPI);
Vue.use(Router);

const router = reactive(new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.params.savePosition) {
      return {};
    }

    if (to.hash) {
      const position = { selector: to.hash };

      return position;
    }

    setTimeout(() => {
      const mainAreaElement = document.querySelector('main.main-area');
      if (mainAreaElement) {
        document.querySelector('main.main-area').scrollTop = 0;
      }
    }, 350);

    return undefined;
  },
  routes: [
    {
      path: '/public',
      component: PublicView,
      children: publicRoutes,
    },
    {
      path: '/',
      beforeEnter: loginNavigationGuard(store),
      component: LoggedIn,
      children: [
        { path: '', component: () => import(/* webpackChunkName: "landingpage" */ '../components/landing/LandingPage.vue') },
        ...privateRoutes,
      ],
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: alreadyLoggedInNavigationGuard(store),
      props: (route) => ({
        superToken: route.query.superToken,
      }),
      component: () => import(/* webpackChunkName: "applogin" */ '../components/login/AppLogin.vue'),
    },
    { path: '*', component: NotFound },
  ],
}));

const currentRoute = reactive({
  ...router.currentRoute,
});

watch(() => router.currentRoute, (newRoute) => {
  Object.keys(newRoute).forEach((key) => {
    currentRoute[key] = newRoute[key];
  });
});

router.beforeEach(underEditNavigationGuard(store));

export function useRoute() {
  return currentRoute;
}

export function useRouter() {
  return router;
}

export default router;
